<template>
  <div>
    <div
      id="container"
      style="width: 1600px;height: 645px"
    />
    <div id="panel" style="display: none"/>
  </div>
</template>

<script>
import AMap from "AMap"; // 引入高德地图AMap
import "@/assets/css/navigation.css";
import { AddressTolongLati, defaultLonLati, SearchDrivingStrategy } from "@/utils/basic";
import { mapState } from "vuex";
import { getSCoordinate } from "./tools/tool";

export default {
  name: "NavMap",
  props: {
    category: {
      type: String,
      default: "",
    },
    carID: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    },
    navForm: {
      type: Object,
      default() {
        return {};
      }
    },
    backHome: { // 通过变动这个来表现回到起点事件
      type: Number,
      default: 0
    }
  },
  emits: ["getLeftTime", "getPopupData"],
  data() {
    return {
      popUpOrigin: [], //  弹窗响应回来的经纬度
      popUpDestination: [], //  弹窗响应回来的经纬度
      currentCarPoint: [], // 当前急救车经纬度 || 最原始的位置,后面肯定是一直在变动的
      gpsData: {}, // gps的一系列数据
      destination: "", //  目标地址 经纬度
      targetLocation: "", // 目标地址 文字
      cycleTimer: null, // 循环计时器,更新地图图标位置
      firstMessage: true, // 第一次消息, 渲染导航
      lastTimeData: {}, // 上一次的数据
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      allPosition: "allPosition",
      currentList: "currentList",
      hospitalInfo: "hospitalInfo"
    }),
  },
  watch: {
    currentList: {
      handler(val) {
        const thisTimeData = JSON.stringify(val.find(item => {
          return item.ambulanceId === this.carID;
        }));
        if (thisTimeData === this.lastTimeData) {
          // 相等 什么事情也不干
        } else {
          // 清空导航, 甚至需要重绘 || 第一次的时候会走到这里...
          this.driving?.clear();
          this.firstMessage = true;
          console.log("清空导航, 甚至需要重绘");
        }
        this.lastTimeData = thisTimeData;
      }
    },
    allPosition: {
      handler(val) {
        setTimeout(
          () => { // 必须要延迟一下, 不然, 刷新的时候, watch可能更快一点, 造成路径规划失败
            this.getMessage(val);
          }, 300
        );
      }
    },
    count: {
      handler(val) {
        const { index, type } = this.navForm;
        // type 0 搜素路线
        if (type === 0) {
          this.searchMap(index);
        } else {
          // type 1 规划路线
          this.setDrivingRoad(index);
        }
      },
      deep: true
    },
    backHome: {
      handler(val) {
        val && this.backHomePosition();
      }
    }
  },
  mounted() {
    this.map = null;
    this.driving = null; // 正常要显示出来的地图规划
    this.initMap();
  },

  beforeUnmount() {
    clearInterval(this.cycleTimer);
    this.cycleTimer = null;
    this.map?.destroy();
    this.map = null;
    this.driving = null;
  },
  methods: {
    // 回到急救车定位
    backHomePosition() {
      this.map.setCenter(this.currentCarPoint);
    },
    async getMessage(val) {
      try {
        let dataJson;
        try {
          dataJson = JSON.parse(val[this.carID]);
        } catch (e) {
          dataJson = val[this.carID];
        }
        if (!dataJson) return;
        this.gpsData = dataJson;
        this.currentCarPoint = [dataJson.longitude, dataJson.dimension];
        const current = this.currentList.find(item => {
          return item.ambulanceId === this.carID;
        });
        // 首先, 必须是第一次渲染, 有终点, 其次必须该车有任务
        const isShowDriving = this.firstMessage && current;
        if (isShowDriving) {
          const { statu, longitude, latitude } = current;
          const status = statu * 1;
          this.firstMessage = false;
          if (status >= 3) { // 患者已经上车, 定位前往医院
            const { longitude, latitude } = this.hospitalInfo;
            this.destination = [longitude, latitude];
          } else { // 患者未上车, 定位前往患者所在地
            this.destination = [longitude, latitude];
          }
          this.beginDriving();
        }
      } catch (e) {
        return false;
      }
    },

    /**
     * 通过高德接口返回对应的导航路径信息
     * @param {string} start - 开始的地址
     * @param {string} dest - 结束的地址
     * @param {Object} target - 储存的信息
     * @param {number} policy - 不同的高德归规划
     * @param {string} type - 不同的高德归规划名称
     * */
    // getRouteData(start, dest, target, policy, type) {
    //   return new Promise((resolve, reject) => {
    //     policy.search([{ keyword: start }, { keyword: dest }], (status, result) => {
    //       if (status === "complete" && result.info === "OK") {
    //         this.handleSearchResult(result.routes[0], target, type);
    //         resolve(result.routes[0]);
    //       } else {
    //         reject(new Error("Failed to get route data. 高德获取接口失败. 请检查是不是超额了"));
    //       }
    //     });
    //   });
    // },

    /*
    * 处理储存的格式
    * */
    handleSearchResult(route, target, detailType) {
      const { time, steps, distance } = route;
      target.time = time;
      target.steps = steps;
      target.distance = distance;
      target.type = detailType;
    },
    /**
     * 这个是点击搜索按钮,然后进行路程规划
     * */
    async searchMap() {
      const { starting: s, destination: d } = this.navForm; //  在此默认调用高德地图API接口,无视其他接口先
      const starting = await AddressTolongLati(s);
      const destination = await AddressTolongLati(d);
      const { origin, paths, destination: target } = await SearchDrivingStrategy({
        origin: starting,
        destination,
        strategy: 11
      });
      this.$emit("getPopupData", paths);
      // console.log(paths);
      this.popUpOrigin = origin.split(",");
      this.popUpDestination = target.split(",");
      // localStorage.setItem("ooo", JSON.stringify(paths));
    },
    /**
     * 设置启用的路线
     * @param {Number} index - 点击的三条路线index
     * */
    setDrivingRoad(index) {
      // 先给选择, 看看是选择哪个
      this.driving?.clear();
      this.realDriving?.clear();
      const { LEAST_TIME, REAL_TRAFFIC, LEAST_DISTANCE } = AMap.DrivingPolicy;
      const plans = [LEAST_DISTANCE, LEAST_TIME, REAL_TRAFFIC];
      // console.log(plans[index]);
      this.realDriving = new AMap.Driving({ map: this.map, panel: "panel", policy: plans[index] });
      //  根据起终点名称规划驾车导航路线
      this.realDriving.search(
        this.popUpOrigin, this.popUpDestination,
        (status, result) => {
          this.$emit("getLeftTime", result.routes[0].time);
        }
      );
    },
    async initMap() {
      const { currentCarPoint: initCarPoint } = await getSCoordinate(this.ambulanceLists, this.carID); // 此时已经把此急救车的经纬度存入data中  || 急救车目标地址也在这里获得了
      this.currentCarPoint = initCarPoint.length ? initCarPoint : defaultLonLati;
      // 这个是点击坐标回到急救车地点
      this.map = new AMap.Map("container", {
        center: [...this.currentCarPoint], // 初始化地图中心点
        resizeEnable: true, // 是否监控地图容器尺寸变化
        zoom: 19, // 初始化地图层级
        lang: "zh_cn", // 设置地图语言类型
      });
      //  在地图上给一个急救车图标
      const ambulanceIcon = new AMap.Icon({
        size: new AMap.Size(48, 48),
        image: this.category === "car" ? require("@/assets/photos/working.png") : this.category === "Plane" ? require("@/assets/icons/plane.png") : require("@/assets/icons/autoCar.png"),
        imageSize: new AMap.Size(48, 48),
      });
      const ambulanceMarker = new AMap.Marker({
        position: this.currentCarPoint,
        icon: ambulanceIcon,
        offset: new AMap.Pixel(0, 0),
      });
      this.map?.add(ambulanceMarker);
      this.cycleTimer = setInterval(() => {
        //  循环更新GPS定位
        if (this.currentCarPoint[0]) {
          ambulanceMarker.setPosition([...this.currentCarPoint]);
        }
      }, 1000);
    },

    beginDriving() {
      this.driving = null;
      this.driving = new AMap.Driving({ map: this.map, panel: "panel" });
      if (!this.currentCarPoint[0]) return; // 如果没有值的话, 就不规划路线了
      this.driving.search(
        new AMap.LngLat(...this.currentCarPoint), // 起点终点都是经纬度的形式
        this.destination,
        (status, result) => {
          if (status === "complete") {
            this.$emit("getLeftTime", result.routes[0].time);
          } else {
            console.log("获取失败");
          }
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">

</style>
